import {BrowserModule} from '@angular/platform-browser';

import {NgModule} from '@angular/core';
import {AngularFireModule} from 'angularfire2';
import {AngularFireDatabaseModule} from 'angularfire2/database';
import {AngularFireAuthModule} from 'angularfire2/auth';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';

import {ModalModule} from 'ngx-bootstrap/modal';
import {TooltipModule} from 'ngx-bootstrap/tooltip';

import {AppComponent} from './app.component';
import {TeamsComponent} from './teams/teams.component';
import {AppRoutingModule} from './app-routing.module';
import {LoginComponent} from './login/login.component';
import {CompaniesComponent} from './companies/companies.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {TimeTrackerService} from './time-tracker-service.service';
import {NavbarComponent} from './navbar/navbar.component';
import {DeviceRegisterComponent} from './device-register/device-register.component';
import {ReportsComponent} from './reports/reports.component';
import {SearchFilterPipe} from './filter/searchFilterPipe';
import {BsModalRef, PopoverModule, TimepickerModule} from 'ngx-bootstrap';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TemplateModalComponent} from './modals/template-modal';
import {AngularFirestoreModule} from 'angularfire2/firestore';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {ScheduleModalComponent} from './modals/schedule-modal';
// Material
import {
    MatAutocompleteModule, MatButtonModule, MatCardModule, MatCheckboxModule, MatChipsModule, MatDatepickerModule,
    MatExpansionModule, MatFormFieldModule, MatIconModule, MatInputModule, MatListModule, MatMenuModule,
    MatNativeDateModule, MatOptionModule, MatPaginatorModule, MatProgressSpinnerModule, MatSelectModule,
    MatSlideToggleModule, MatSnackBarModule, MatStepperModule, MatTableModule, MatTabsModule
} from '@angular/material';
import {BrowserAnimationsModule, NoopAnimationsModule} from '@angular/platform-browser/animations';
import {RegisterComponent} from './register/register.component';
import {ImageService} from './services/ImageService';
import {ScheduleService} from './services/ScheduleService';
import {SettingsComponent} from './settings/settings.component';
import {ScoreComponent} from './score/score.component';
import {UserProfileModalComponent} from './modals/userprofile-modal';
import {ReasonModalComponent} from './modals/template-reason-modal';
import {DeviceModalComponent} from './modals/device-modal';
import {TeamModalComponent} from './modals/team-modal';
import {AllowedDeviceModalComponent} from './modals/template-allowed-device-modal';


export const firebaseConfig = {
    apiKey: 'AIzaSyAUgHEZbw9MCQEUpWfK9bmHq_j4FW_isHg',
    authDomain: 'time-tracker-82e5f.firebaseapp.com',
    databaseURL: 'https://time-tracker-82e5f.firebaseio.com',
    storageBucket: 'time-tracker-82e5f.appspot.com',
    messagingSenderId: '1022173678576',
    projectId: 'time-tracker-82e5f-dev'
};

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [
        AppComponent,
        TemplateModalComponent,
        ScheduleModalComponent,
        ReasonModalComponent,
        UserProfileModalComponent,
        SearchFilterPipe,
        TeamsComponent,
        LoginComponent,
        CompaniesComponent,
        DashboardComponent,
        NavbarComponent,
        DeviceRegisterComponent,
        ReportsComponent,
        RegisterComponent,
        SettingsComponent,
        ScoreComponent,
        DeviceModalComponent,
        TeamModalComponent,
        AllowedDeviceModalComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        HttpModule,
        AppRoutingModule,
        AngularFireModule.initializeApp(firebaseConfig),
        AngularFireDatabaseModule,
        AngularFireAuthModule,
        AngularFirestoreModule,
        TooltipModule.forRoot(),
        PopoverModule.forRoot(),
        TimepickerModule.forRoot(),
        ModalModule.forRoot(),
        BrowserAnimationsModule,
        NoopAnimationsModule,
        ReactiveFormsModule,
        MatButtonModule, MatCheckboxModule, MatFormFieldModule, MatInputModule, MatCardModule, MatSnackBarModule,
        MatOptionModule, MatSelectModule, MatListModule, MatIconModule, MatTableModule, MatPaginatorModule,
        MatDatepickerModule, MatNativeDateModule, MatChipsModule, MatAutocompleteModule, MatExpansionModule,
        MatTabsModule, MatStepperModule, MatMenuModule, MatProgressSpinnerModule, MatSlideToggleModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    providers: [TimeTrackerService, BsModalRef, ImageService, ScheduleService],
    bootstrap: [AppComponent],
    entryComponents: [TemplateModalComponent, ScheduleModalComponent, UserProfileModalComponent, ReasonModalComponent, AllowedDeviceModalComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts